import AuthContext from '../../context/AuthContext'
import { Breadcrumb, BreadcrumbItem } from 'carbon-components-react'
import { useHistory } from 'react-router-dom'
import React, { useEffect, useState, useMemo, useContext, useRef } from 'react'
import { AgreementsList } from './agreementList.tsx'
import Toast from '../../components/Notification/Toast'
import { sleep } from '../../utils/functions/tools/sleep';
const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;

const API_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const AgreementList = () => {

    const dupForm = useRef();

    let { authTokens } = useContext(AuthContext)

    const [list, setList] = useState([]);
    let toastProperties = null;
    let [openDeleteModal, setOpenDeleteModal] = useState(false)
    let [openDupModal, setOpenDupModal] = useState(false)
    let [error, setError] = useState(null)
    let [clientsToDel, setClientsToDel] = useState(null)
    let [dup, setDup] = useState(null)
    const history = useHistory()

    const [totalItems, setTotalItems] = useState(0);
    const [firstRowIndex, setFirstRowIndex] = useState(0);
    const [currentPageSize, setCurrentPageSize] = useState(10);

    const [curDate, setCurDate] = useState(null)

    // Variables for search
    const [clientSearch, setClientSearch] = useState("");

    let [clients, setClients] = useState([])
    
    let getClients = async () => {
        let response = await fetch(`${API_URL}/agreements/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })
        let data = await response.json()
        setClients(data)
    }

    let batchDelete = async (selectedClients) => {
        selectedClients.map((client) => deleteClient(client.id))
    }

    useEffect(() => {
        getClients()
        document.title = "Agreements | WillowBMS"
        let date = new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).slice(-2) + '-' + ('0' + new Date().getDate()).slice(-2)
        setCurDate(date)
    }, [])

    const showToast = (type, title, description) => {
        const id = Math.floor((Math.random() * 100) + 1);
        const time = new Date().toLocaleString();

        switch (type) {
            case 'success':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'success',
                    time: time
                }
                break;
            case 'error':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'error',
                    time: time
                }
                break;
            case 'info':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'info',
                    time: time
                }
                break;
            case 'warning':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'warning',
                    time: time
                }
                break;
            default:
                setList([]);
        }
        setList([...list, toastProperties]);
    }

    let deleteClient = async (agreementID) => {
        let response = await fetch(`${API_URL}/agreements/${agreementID}/`, {
            method: 'DELETE',
            'headers': {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })

        if (response.status === 200) {
            showToast("success", "Success", "Agreement(s) have been deleted.")
            getClients()
            setError(false)
            setOpenDeleteModal(false)
        } else {
            setError(true)
        }
    }

    let duplicateAgreement = async (values) => {
        values.preventDefault()
        let response = await fetch(`${API_URL}/agreements/duplicate/${dup}/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({
                'name': values.target.name.value,
                'startdate': values.target.startdate.value,
                'enddate' : values.target.enddate.value
            })
        })

        let data = await response.json()
        let newAgreement = await JSON.parse(data)["newAgreement"]
        if (response.status === 200) {
            showToast("success", "Success", "Selected agreement has been duplicated and agreement #" + newAgreement + " has been created.")
            setOpenDupModal(false)
            setError(false)
            await sleep(2000)
            history.push(`/agreements/${newAgreement}`)
        } else {
            setError(true)
        }
    }

    const clientsData = useMemo(() => {
        let computedClients = search(clients);
        setTotalItems(computedClients.length);
        //Current Page slice
        return computedClients.slice(
            firstRowIndex,
            firstRowIndex + currentPageSize
        );
    }, [clients, firstRowIndex, currentPageSize, clientSearch]);

    const clientListHeaders = [
        { label: "ID", key: "id" },
        { label: "Company", key: "company" },
        { label: "Status", key: "status" },
        { label: "Phone Number", key: "phoneNumber" },
        { label: "Client Since", key: "dateSince" },
    ];

    const clientListReport = {
        data: clients,
        headers: clientListHeaders,
        filename: `client_list_report.csv`
    };

    function search(clients) {
        return clients.filter(
            (row) =>
                row.name.toLowerCase().indexOf(clientSearch) > -1 ||
                row.name.indexOf(clientSearch) > -1
        );
    }

    return (
        <div id="body" className="bms-page d-flex">
            <Toast toastList={list} />
            <div className="wrapper">
                <Breadcrumb>
                    <BreadcrumbItem href="/">Agreements</BreadcrumbItem>
                </Breadcrumb>
                <h2>
                    Agreement List
                </h2>

                <AgreementsList curDate={curDate} dup={dup} setDup={setDup} dupForm={dupForm} duplicateAgreement={duplicateAgreement} openDupModal={openDupModal} setOpenDupModal={setOpenDupModal} clientListReport={clientListReport} setClientsToDel={setClientsToDel} clientsToDel={clientsToDel} error={error} setError={setError} setOpenDeleteModal={setOpenDeleteModal} openDeleteModal={openDeleteModal} batchDelete={batchDelete} rows={clientsData} totalItems={totalItems} currentPageSize={currentPageSize} setCurrentPageSize={setCurrentPageSize} setFirstRowIndex={setFirstRowIndex} setClientSearch={setClientSearch} />

            </div>
        </div>
    )
}

export default AgreementList